import React from 'react';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from '@mui/material';

type DismissAllConfirmModalProps = {
  open: boolean;
  onCancel: () => void;
  onConfirm: () => void;
};

const DismissAllConfirmModal = ({
  open,
  onCancel,
  onConfirm,
}: DismissAllConfirmModalProps) => (
  <Dialog open={open} onClose={onCancel} fullWidth maxWidth="xs">
    <DialogTitle>Dismiss all AI-generated data?</DialogTitle>
    <DialogContent>
      <Typography variant="body" color="text.secondary">
        All sections will be dismissed. This can&apos;t be undone.
      </Typography>
    </DialogContent>
    <DialogActions>
      <Button variant="contained" color="primary" onClick={onConfirm}>
        Dismiss All
      </Button>
      <Button variant="outlined" color="primary" onClick={onCancel}>
        Go Back
      </Button>
    </DialogActions>
  </Dialog>
);

export default DismissAllConfirmModal;
